import React from "react";
import { useLanguage } from "../../../../contexts";
import { ASPECT_COLOR, mixHex } from "./visualColors";
import { formatShortDate, fracFecha, GridYears, YearAxis } from "./roadmapHelpers";

const LABEL_WIDTH = 112;

// Mapa de ruta en "carriles": una franja horizontal por aspecto, con una
// píldora por meta posicionada por fecha. Puerto de renderRoadCarriles() del
// mockup de referencia.
export function RoadmapLanes({ groups, baseYear, horizonEnd }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const horizon = horizonEnd - baseYear;

  return (
    <div style={{ maxWidth: 860, margin: "0 auto" }}>
      <YearAxis baseYear={baseYear} horizon={horizon} margin={LABEL_WIDTH} />
      {groups.map(({ aspect, objetivos }) => {
        const color = ASPECT_COLOR[aspect] || "#5E89B4";
        const metas = [];
        objetivos.forEach((o) => (o.metas || []).forEach((m) => metas.push({ m, o })));
        return (
          <div key={aspect} style={{ display: "flex", marginTop: 8, pageBreakInside: "avoid" }}>
            <div style={{ width: LABEL_WIDTH, background: color, color: "#fff", borderRadius: "8px 0 0 8px", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Sora',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: 1 }}>
              {t(aspect).toUpperCase()}
            </div>
            <div style={{ flex: 1, background: mixHex(color, 0.93), borderRadius: "0 8px 8px 0", padding: "7px 0", position: "relative" }}>
              <GridYears horizon={horizon} />
              {metas.map(({ m, o }) => {
                const x0 = fracFecha(m.fechaInicio, baseYear, horizonEnd) * 100;
                const x1 = Math.max(fracFecha(m.fechaFin, baseYear, horizonEnd) * 100, x0 + 2);
                return (
                  <div key={m._id} style={{ position: "relative", height: 19, margin: "3px 0" }}>
                    <div
                      title={`${o.code} · ${m.description} · ${formatShortDate(m.fechaInicio)} → ${formatShortDate(m.fechaFin)}`}
                      style={{ position: "absolute", left: `${x0.toFixed(1)}%`, width: `${(x1 - x0).toFixed(1)}%`, top: 0, bottom: 0, background: "#fff", border: `1.5px solid ${color}`, borderRadius: 10, fontSize: 9.5, color, fontWeight: 600, display: "flex", alignItems: "center", padding: "0 7px", overflow: "hidden", whiteSpace: "nowrap" }}
                    >
                      {m.code} {m.description.length > 34 ? `${m.description.slice(0, 34)}…` : m.description}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
